import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { networkArchitecture, networkAudit, networkOperationCentre, technologyDeploymentBanner } from 'images/expertise';
import DetailPage from 'containers/expertise/DetailPage';

const Noc: NextPage = () => {
  return (
    <>
      <Header
        title="Network Operation Center (NOC)"
        description="We aim to free up customers' resources and remove the burden of various network technologies, protocols, and network issues. USS supplies all the network services - monitoring, auditing, design, and implementation. All under one roof."
        image={technologyDeploymentBanner}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: networkOperationCentre,
            id: 'networkOperationCentre',
            title: 'Network Operation Centre',
            hasListItems: true,
            description:
              'We strive to maintain optimal network performance and availability and ensure continuous uptime, monitoring, and maintenance for problems requiring special attention.',
            listItems: [
              { text: 'Network Monitoring and updates' },
              { text: 'Performance and quality reporting' },
              { text: 'Control Implementation' },
              { text: 'Network Security Management' },
            ],
          },
          {
            bgImage: networkAudit,
            id: 'networkAudit',
            title: 'Network Audit',
            hasListItems: true,
            description:
              'We are mapping and inventorying your network in terms of hardware and software. The data is gathered, vulnerabilities and threats are identified, and a formal audit report is sent to the customer.',
            listItems: [
              { text: 'Performance Analysis' },
              { text: 'Security Infrastructure Analysis ' },
              { text: 'Traffic Analysis' },
            ],
          },
          {
            bgImage: networkArchitecture,
            id: 'networkArchitecture',
            title: 'Network Architecture',
            hasListItems: true,
            description:
              "We're designing a network from the ground up or expanding an existing network. Utilities One brings an unparalleled level of experience and knowledge to network design and network architecture.",
            listItems: [
              { text: 'Analysis of the current Network Infrastructure' },
              { text: 'Re-design of the Network Segments' },
              { text: 'Design of the new Network Segments' },
              { text: 'Network Documentation' },
            ],
          },
        ]}
      />
    </>
  );
};

export default Noc;
